export default {
  'validation.afterToday': 'Date must be later than today',
  'validation.alphaNumeric': 'Only alphanumeric characters allowed',
  'validation.businessDay': 'Only allowed on valid business days',
  'validation.futureDatesNotAllowed': 'Future Dates Not Allowed',
  'validation.holidays': 'Cannot be on a business holiday',
  'validation.invalidOption': 'Please select a valid option',
  'validation.maxDate': 'Date cannot be after <%=max %>',
  'validation.maxNCharacters': 'Max <%=max %> characters',
  'validation.minNCharacters': 'Min <%=min %> characters',
  'validation.maxNNumbers': 'Max <%=max %> numbers',
  'validation.minNNumbers': 'Min <%=min %> numbers',
  'validation.minDate': 'Date cannot be before <%=min %>',
  'validation.notZero': 'Cannot be 0',
  'validation.pastDatesNotAllowed': 'Past Dates Not Allowed',
  'validation.phone': 'Not a valid phone number',
  'validation.regexp': 'Only alphanumeric, space or #-$.&*, characters allowed',
  'validation.numeric': 'Only numeric characters allowed',
  'validation.required': 'Required field cannot be blank',
  'validation.weekdays': 'Please select atleast one day of the week.',
  'validation.email': 'The email address is invalid',
  'validation.emailMismatch': 'Email address does not match',
  'validation.invalidCharacters': 'Invalid characters',
  'validation.invalidAddress': 'Address cannot contain the following characters )(&=<>',
  'validation.invalidCityName': 'City name cannot contain the following characters )(&=<>',
  'validation.invalidState': 'State can contain only A-Z',
  'validation.checkingBankCodeNumber': '...checking Bank Code / Number',
  'validation.invalidBankCodeNumber': 'Invalid Bank Code / Number',
  'validation.duplicateField': 'Duplicate field'
};
